import { render } from "./AmendmentsModal.vue?vue&type=template&id=855f1f64"
import script from "./AmendmentsModal.vue?vue&type=script&lang=js"
export * from "./AmendmentsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__